import { useTranslation } from 'react-i18next';
import { AlertCircle, RotateCw } from 'lucide-react';
import { cn } from 'lib/utils';
import { Skeleton } from 'components/ui/skeleton';
import { GRID_COLS } from './tableColumns';

/** A batch's child rows while loading (two skeletons) or after a failed load (retry); rows only, no rowgroup. */
const ChildRowsStatus = ({ isError, onRetry }: { isError: boolean; onRetry: () => void }) => {
  const { t } = useTranslation();
  if (!isError) {
    return (
      <>
        {[0, 1].map((row) => (
          <div key={row} role="row" className={cn('grid items-center gap-3 border-b pl-8 pr-4', GRID_COLS)} style={{ height: 44 }}>
            <Skeleton role="cell" className="h-3.5 w-3/5" />
          </div>
        ))}
      </>
    );
  }

  return (
    <div role="row" className="border-b py-2 pl-8 pr-4">
      <div role="cell" className="flex items-center gap-2 text-[12.5px] text-rose-600 dark:text-rose-400">
        <AlertCircle className="h-3.5 w-3.5" aria-hidden="true" />
        {t('An error occurred')}
        <button type="button" onClick={onRetry} className="inline-flex items-center gap-1 font-medium underline hover:no-underline">
          <RotateCw className="h-3.5 w-3.5" aria-hidden="true" />
          {t('Retry')}
        </button>
      </div>
    </div>
  );
};

export default ChildRowsStatus;
